import { NgModule } from '@angular/core';
import { DsIconService } from './services/icon.service';
import { dsAddIconsToServiceStatic } from './helpers';
import { smallIcons } from './images/small';
import { mediumIcons } from './images/medium';

@NgModule()
export class DsDefaultIconsModule {
  constructor(private dsIconService: DsIconService) {
    dsAddIconsToServiceStatic(smallIcons, this.dsIconService, 'default', 's');
    dsAddIconsToServiceStatic(mediumIcons, this.dsIconService, 'default', 'm');
  }
}
